<template>
  <div>
    <div class="category-top-bar" ref="optionsTopBar">
      <div class="top-bar">
        <p>
          <a class="btn btn-orange btn-icon back" @click="goBack">
            <i class="ti-arrow-left"></i>
            {{ $t('general.back') }}
          </a>
        </p>
        <p class="d-inline-flex">
            <button type="submit" class="btn btn-icon btn-success mar-rt-10 save" style="margin-bottom: 0;" @click="saveMyOrder()" :title="$t('general.save')">
              <img src="/static/img/icons/save.png">
              {{ $t('general.save') }}
            </button>
        </p>
      </div>
    </div>
    <div class="card">
      <div class="card-content">
        <div class="modal-header">
          <p>{{ modalOrderTitle }}</p>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-2">
              <div class="form-group">
                <label>Comanda pentru locatia</label>
                <select class="form-control" v-model="selectedLocationId" :disabled="isEdit || isReception || isValidate">
                  <option value="" disabled>Selectează locația</option>
                  <optgroup
                    v-for="group in groupedLocations"
                    :key="group.vat"
                    :label="`VAT: ${group.vat}`"
                  >
                    <option
                      v-for="loc in group.locations"
                      :key="loc.true_id"
                      :value="loc.true_id"
                    >
                      {{ loc.name }}
                    </option>
                  </optgroup>
                </select>
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-group">
                <label>Din locatiile cu gestiune tip depozit</label>
                <select class="form-control" v-model="selectedDepositLocationId" :disabled="isEdit || isReception || isValidate">
                  <option disabled value="">Selectează locația depozit</option>
                  <option
                    v-for="loc in locationsWithDepositGestiune"
                    :key="loc.true_id"
                    :value="loc.true_id"
                  >
                    {{ loc.name }}
                  </option>
                </select>
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-group">
                <label for="serie">{{ $t('invoice.series') }}*</label>
                <el-select v-model="myOrder.serie" placeholder="Selectează seria" :disabled="isReception || isValidate" @change="handleSerieChange">
                    <el-option
                      v-for="serie in seriesOptionsWithAdd"
                      :key="serie.id"
                      :label="serie.id === 'add' ? serie.name : `${serie.name} - ${serie.currentNumber}`"
                      :value="serie.id"
                    ></el-option>
                </el-select>
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-group">
                <label for="data">{{ $t('gestiune.data') }}</label>
                <el-date-picker
                  v-model="myOrder.date"
                  type="date"
                  placeholder="Selectează data"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card mar-to-15">
      <div class="card-content">
        <div class="col-md-12">
          <p>{{$t('gestiune.addProductInOrder')}}</p>
          <hr class="sm">
        </div>

        <table class="table">
          <thead>
            <tr>
              <th v-if="isReception || isValidate">{{ $t('gestiune.gestiune') }}*</th>
              <th>{{ $t('invoice.productName') }}*</th>
              <th>{{ $t('gestiune.codeProduct') }}*</th>
              <th>{{ $t('invoice.unitMeasure') }}*</th>
              <th>{{ $t('gestiune.quantityScriptic') }}*</th>
              <th v-if="isReception || isValidate">{{ $t('gestiune.quantityFaptic') }}*</th>
              <th v-if="isReception || isValidate">Preț fără TVA</th>
              <th v-if="isReception || isValidate">{{ $t('invoice.vatPercent') }}</th>
              <th v-if="isReception || isValidate">{{ $t('invoice.vatValue') }}</th>
              <th>{{ $t('general.actions') }}</th>
            </tr>
          </thead>
          <tbody>
            <!-- Rânduri deja adăugate -->
            <tr v-for="(item, index) in items" :key="index">
              <td v-if="isReception || isValidate">
                {{
                  gestiuneOptions.find(g => g.id === item.gestiune).name || '—'
                }}
              </td>
              <td>{{ typeof item.productName === 'object' ? item.productName.name : item.productName }}</td>
              <td>{{ item.code }}</td>
              <td>{{ item.unitMeasure }}</td>
              <td>{{ item.quantity_scriptic }}</td>
              <td v-if="isReception || isValidate">
                <input
                  type="number"
                  v-model.number="item.quantity_faptic"
                  class="form-control"
                  min="0"
                />
              </td>
              <td v-if="isReception || isValidate">{{ item.pret_fara_tva }}</td>
              <td v-if="isReception || isValidate">{{ item.tva_percent }}</td>
              <td v-if="isReception || isValidate">{{ item.vatValue }}</td>
              <td>
                <a
                  class="btn btn-danger btn-icon delete mar-rt-10"
                  :class="{ disabled: isReception || isValidate }"
                  @click="removeItem(index)"
                  :disabled="isReception || isValidate"
                >
                  <img src="/static/img/icons/icon-close.png" />
                  {{ $t('general.delete') }}
                </a>
              </td>
            </tr>

            <!-- Rând de adăugare -->
            <tr v-if="!isReception && !isValidate">
              <td style="width: 250px !important;">
                <v-select
                  v-model="newItem.productName"
                  :options="searchResults"
                  label="name"
                  placeholder="Caută un produs..."
                  :filterable="false"
                  @search="onInputSearch($event)"
                  @input="onProductSelected"
                >
                  <template #no-options>
                    <span v-if="!loading">Niciun produs găsit</span>
                  </template>
                </v-select>

                <div class="v-select-loader" v-if="loading"></div>
              </td>

              <td>
                <input
                  type="text"
                  class="form-control"
                  v-model="newItem.code"
                  placeholder="Cod"
                  disabled
                />
              </td>

              <td>
                <select v-model="newItem.unitMeasure" class="form-control" disabled>
                   <option :value="newItem.unitMeasure">{{newItem.unitMeasure}}</option>
                </select>
              </td>

              <td>
                <input
                  type="number"
                  class="form-control"
                  v-model.number="newItem.quantity_scriptic"
                  :placeholder="$t('gestiune.quantityScriptic')"
                />
              </td>

              <td v-if="isReception || isValidate">
                <input
                  type="number"
                  class="form-control"
                  v-model.number="newItem.quantity_faptic"
                  :placeholder="$t('gestiune.quantityFaptic')"
                />
              </td>

              <td v-if="isReception || isValidate">
                <input
                  type="number"
                  class="form-control"
                  v-model.number="newItem.pret_fara_tva"
                  placeholder="Preț fără TVA"
                />
              </td>

              <td v-if="isReception || isValidate">
                <input
                  type="number"
                  class="form-control"
                  v-model.number="newItem.tva_percent"
                  disabled
                />
              </td>

              <td v-if="isReception || isValidate">
                <input
                  type="number"
                  class="form-control"
                  :value="calculateVatValue(newItem)"
                  disabled
                />
              </td>

              <td>
                <button class="btn btn-primary" @click="addItem">
                  {{ $t('general.add') }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <ManagementSeriesAdd
      :locations="locations"
      :grouped-locations="groupedLocations"
      :vat-number="selectedLocation ? selectedLocation.inv_fiscal_code : ''"
      @getSeries="getSeries"
    />
  </div>
</template>

<script>
import PSwitch from 'src/components/UIComponents/Switch.vue'
import ManagementSeriesAdd from '../../Management/ManagementSeriesAdd.vue'
import swal from 'sweetalert2'
export default {
  components: {
    PSwitch,
    ManagementSeriesAdd
  },
  props: {
    route: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      loading: false,
      selectedLocationId: '',
      selectedDepositLocationId: '',
      locations: [],
      gestiuneOptions: [],
      seriesOptions: [],
      searchResults: [],
      currencyOptions: [
        { code: 'RON', name: 'Leu Românesc (RON)' },
        { code: 'EUR', name: 'Euro (EUR)' },
        { code: 'USD', name: 'Dolar American (USD)' }
      ],
      isEdit: !!this.route.params.series && !!this.route.params.number,
      myOrder: {
        date: new Date()
      },
      tableData: [],
      mesurementsUnits: [],
      selectedLocation: null,
      isReception: false,
      onFetchProductsTimeout: null,
      isValidate: false,
      items: [],
      newItem: {
        gestiune: null,
        productName: null,
        code: '',
        unitMeasure: '',
        quantity_scriptic: 1,
        quantity_faptic: 0,
        pret_fara_tva: 0,
        tva_percent: 19,
        vatValue: 0
      },
      selectedSerieName: '',
      seriePromiseResolver: null
    }
  },
  created () {
    this.companyID = this.$session.get('selectedCompany')

    this.fetchLocation()
    this.fetchGestiuni()
  },
  watch: {
    selectedLocationId (id) {
      for (const group of this.groupedLocations) {
        const loc = group.locations.find(l => l.true_id === id)
        if (loc) {
          this.selectedLocation = loc

          const { series, number, isReception, isValidate } = this.route.query
          this.isReception = (isReception === 'true' || isReception === true)
          this.isValidate = (isValidate === 'true' || isValidate === true)

          // NU apelăm getSeries dacă e validate sau reception
          const shouldSkipSeries = this.isValidate || this.isReception

          if (!shouldSkipSeries && series && number && loc.inv_fiscal_code) {
            this.getSeries(loc.inv_fiscal_code)
          } else if (!this.isEdit && !shouldSkipSeries && loc.inv_fiscal_code) {
            this.getSeries(loc.inv_fiscal_code)
          }

          break
        }
      }
    },
    locations (newLocations) {
      if (newLocations && newLocations.length) {
        const { series, number, isReception, isValidate } = this.route.query
        this.isReception = (isReception === 'true' || isReception === true)
        this.isValidate = (isValidate === 'true' || isValidate === true)
        if (series && number && (this.isReception || this.isValidate)) {
          this.fetchOrder(series, number)
        }
      }
    }
  },
  computed: {
    seriesOptionsWithAdd () {
      return [
        ...this.seriesOptions,
        { id: 'add', name: '➕ Adaugă serie' }
      ]
    },
    groupedLocations () {
      const groups = {}

      if (!this.locations || !this.locations.length) return []

      this.locations.forEach(location => {
        const vat = location.inv_fiscal_code || 'Fără cod fiscal'
        if (!groups[vat]) {
          groups[vat] = []
        }
        groups[vat].push(location)
      })

      const result = Object.entries(groups).map(([vat, locations]) => ({
        vat,
        locations
      }))

      return result
    },
    locationsWithDepositGestiune () {
      if (!Array.isArray(this.gestiuneOptions) || !this.gestiuneOptions.length ||
          !Array.isArray(this.locations) || !this.locations.length) {
        return []
      }

      const locationIdsFromDepositGestiuni = this.gestiuneOptions
        .filter(g => g.is_depozit === true)
        .map(g => g.externalLocationId)

      return this.locations.filter(loc =>
        locationIdsFromDepositGestiuni.includes(loc.true_id)
      )
    },
    filteredGestiuni () {
      if (!this.selectedLocationId) return []
      const result = this.gestiuneOptions.filter(
        (g) => g.externalLocationId === this.selectedLocationId
      )
      return result
    },
    modalOrderTitle () {
      if (this.isReception) {
        return this.$t('gestiune.receptionOrder')
      } else if (this.isValidate) {
        return this.$t('gestiune.validateOrder')
      } else {
        return this.$t('gestiune.addOrder')
      }
    }
  },
  methods: {
    resetNewItem () {
      this.newItem = {
        productName: null,
        code: '',
        unitMeasure: '',
        quantity_scriptic: 0,
        quantity_faptic: 0,
        pret_fara_tva: 0,
        tva_percent: 19,
        vatValue: 0
      }
    },
    handleSerieChange (val) {
      if (val === 'add') {
        this.openSeriesModal()
        this.myOrder.serie = null
      }
    },
    openSeriesModal () {
      this.$modal.show('addSeriesModal')
    },
    calculateVatValue (item) {
      const quantity = parseFloat(item.quantity_scriptic) || 0
      const price = parseFloat(item.pret_fara_tva) || 0
      const percent = parseFloat(item.tva_percent) || 0
      const vat = (quantity * price) * percent / 100
      return Number(vat.toFixed(2))
    },
    addItem () {
      const item = {
        ...this.newItem,
        vatValue: this.calculateVatValue(this.newItem)
      }
      this.items.push(item)
      this.resetNewItem()
    },
    removeItem (index) {
      this.items.splice(index, 1)
    },
    async fetchLocation () {
      const dataToSend = {
        company_id: this.companyID,
        token: this.$session.get('token')
      }

      this.apiRequest('/gestiune/locations', 'GET', dataToSend, (response) => {
        if (!response || response.status !== true || !response.data || !response.data.locations) {
          swal({
            title: 'Eroare!',
            text: response.message || 'Eroare la preluarea locațiilor.',
            type: 'error',
            timer: 3000,
            showConfirmButton: false
          })
          return
        }

        this.locations = response.data.locations
      })
    },
    fetchProducts (searchTerm) {
      if (!this.selectedLocation || !searchTerm || searchTerm.length < 2) {
        this.searchResults = []
        return
      }

      this.loading = true
      fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/products?vatNumber=${this.selectedLocation.inv_fiscal_code}&name=${encodeURIComponent(searchTerm)}&externalCompanyId=${this.companyID}`)
        .then(res => res.json())
        .then(data => {
          if (Array.isArray(data.products)) {
            this.searchResults = data.products
          } else {
            this.searchResults = []
          }
        })
        .catch(err => {
          console.error('Error fetching products:', err)
          this.searchResults = []
        })
        .finally(() => {
          this.loading = false
        })
    },

    // funcție debounce pentru input
    onInputSearch (searchTerm) {
      clearTimeout(this.onFetchProductsTimeout)
      this.onFetchProductsTimeout = setTimeout(() => {
        this.fetchProducts(searchTerm)
      }, 500) // debounce 500ms
    },
    onProductSelected (product) {
      if (product && typeof product === 'object') {
        this.newItem.posId = product.posId || product._id
        this.newItem.productName = product.name || ''
        this.newItem.code = product.product_code || ''
        this.newItem.unitMeasure = product.um || ''
        this.newItem.tva_percent = product.vat_percent || 0
        this.newItem.pret_fara_tva =
          Array.isArray(product.pret_vanzare) && product.pret_vanzare.length > 0
            ? product.pret_vanzare[0].price
            : 0
      }
    },
    async fetchGestiuni () {
      try {
        const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/gestiuni?externalCompanyId=${this.companyID}`)
        if (!response.ok) throw new Error('Failed to fetch gestiuni')

        const data = await response.json()
        console.log('Date primite de la server:', data.gestiuni)
        if (data && data.gestiuni && Array.isArray(data.gestiuni)) {
          this.gestiuneOptions = data.gestiuni.map(gest => ({
            id: gest._id,
            name: `${gest.name} (${gest.cod_gestiune})`,
            vatNumber: gest.vatNumber || '',
            externalLocationId: gest.externalLocationId || null,
            is_depozit: gest.is_depozit || false
          }))
        } else {
          swal({
            title: 'Error!',
            text: 'Nu s-a primit un array valid de la server.',
            type: 'error',
            timer: 2000,
            showConfirmButton: false
          })
        }
      } catch (error) {
        swal({
          title: 'Error!',
          text: `Request failed: ${error.message}`,
          type: 'error',
          timer: 2000,
          showConfirmButton: false
        })
        console.error('Error fetching management data:', error)
      }
    },
    async getSeries (vatNumber) {
      try {
        const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/getSeries`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            externalCompanyId: this.companyID,
            vatNumber: vatNumber,
            tip: 'order'
          })
        })

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`)
        }

        const data = await response.json()
        console.log('Serii primite:', data.series)

        if (Array.isArray(data.series)) {
          const mappedSeries = data.series.map(serie => ({
            id: serie._id,
            name: serie.series,
            currentNumber: serie.currentNumber
          }))

          this.seriesOptions = mappedSeries
        } else {
          console.error('Format invalid pentru series:', data)
        }
      } catch (error) {
        console.error('Error fetching series:', error)
      }
    },
    async saveMyOrder () {
      if (!this.items || this.items.length === 0) {
        await swal({
          title: 'Eroare',
          text: 'Trebuie să adaugi cel puțin un produs înainte de a salva comanda.',
          icon: 'warning',
          timer: 2000,
          showConfirmButton: true
        })
        return
      }

      const selectedSerie = this.seriesOptions.find(
        serie => serie.id === this.myOrder.serie || serie.name === this.myOrder.serie
      )
      const serieName = selectedSerie ? selectedSerie.name : this.myOrder.serie || null
      const nextNumber = selectedSerie && selectedSerie.currentNumber ? selectedSerie.currentNumber : this.myOrder.currentNumber || null

      const selectedGestiune = this.gestiuneOptions.find(
        gest => gest.id === this.myOrder.gestiune
      )

      const depositLocations = this.locationsWithDepositGestiune || []
      const selectedDepositLocation = depositLocations.find(loc => loc.true_id === this.selectedDepositLocationId)

      const supplierVatNumber = selectedDepositLocation ? selectedDepositLocation.inv_fiscal_code : null
      const supplierExternalLocationId = selectedDepositLocation ? selectedDepositLocation.true_id : null

      const myOrderData = {
        status: this.isValidate ? 'validat' : (this.isReception ? 'receptionat' : 'new'),
        externalDocIds: {
          ...(typeof this.myOrder.externalDocIds === 'object' && this.myOrder.externalDocIds !== null
            ? this.myOrder.externalDocIds
            : {})
        },
        products: this.items,
        externalLocationId: this.selectedLocation.true_id,
        vatNumber: this.selectedLocation.inv_fiscal_code,
        externalCompanyId: this.companyID,
        supplierExternalLocationId: supplierExternalLocationId,
        supplierVatNumber: supplierVatNumber,
        gestiune: selectedGestiune ? selectedGestiune.id : this.myOrder.gestiune,
        series: serieName,
        number: nextNumber,
        date: this.myOrder.date ? new Date(this.myOrder.date).toISOString() : new Date().toISOString()
      }

      try {
        const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/order`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(myOrderData)
        })

        const data = await response.json()

        if (response.ok) {
          console.log('Comanda salvată cu succes!', data)
          swal({
            title: 'Succes',
            text: 'Comanda a fost salvată cu succes!',
            type: 'success',
            timer: 1500,
            showConfirmButton: false
          })
          // this.router.push('/management/sidebar?tab=ordersSuppliers')
          this.$bus.$emit('refresh')
          this.$bus.$emit('close-modal')
        } else {
          console.error('Eroare la salvarea comenzii', data)

          swal({
            title: 'Eroare',
            text: 'A apărut o eroare la salvarea comenzii.',
            type: 'error',
            timer: 1500,
            showConfirmButton: false
          })
        }
      } catch (error) {
        console.error('Eroare la trimiterea cererii', error)

        swal({
          title: 'Eroare',
          text: 'A apărut o problemă la trimiterea cererii.',
          type: 'error',
          timer: 1500,
          showConfirmButton: false
        })
      }
    },
    openAddProductModal () {
      this.$modal.show('addProductModal')
    },
    goBack () {
      this.$bus.$emit('refresh')
      this.$bus.$emit('close-modal')
    },
    async fetchOrder (series, number) {
      try {
        const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/order?series=${series}&number=${number}&externalCompanyId=${this.companyID}`)
        if (!response.ok) {
          throw new Error(`Eroare la fetch order: ${response.status}`)
        }

        const data = await response.json()

        console.log('Comandă primită:', data)

        if (data) {
          const order = data

          console.log('Order details:', order)

          // Înlocuim complet obiectul myOrder pentru reactivitate
          this.myOrder = {
            date: order.date ? order.date.slice(0, 10) : '',
            location_id: order.externalLocationId || null,
            gestiune: order.gestiune || null,
            serie: order.series || null,
            externalDocIds: order.externalDocIds || {},
            currentNumber: order.number || null,
            supplierVatNumber: order.supplierVatNumber || '',
            supplierExternalLocationId: order.supplierExternalLocationId || null,
            vatNumber: order.vatNumber || '',
            // Dacă ai alte câmpuri în myOrder inițial, păstrează-le, de exemplu:
            currency: this.myOrder.currency || 'RON',
            manager: this.myOrder.manager || '',
            receiver: this.myOrder.receiver || '',
            internalNote: this.myOrder.internalNote || '',
            commandProject: this.myOrder.commandProject || ''
          }

          this.items = order.products || []

          if (order.externalLocationId && this.locations && this.locations.length) {
            let foundLocation = this.locations.find(loc => loc.true_id === order.externalLocationId)

            if (!foundLocation && order.vatNumber) {
              foundLocation = this.locations.find(loc => loc.inv_fiscal_code === order.vatNumber)
            }

            if (foundLocation) {
              this.selectedLocationId = foundLocation.true_id
            }
          }

          if (order.supplierExternalLocationId && this.locationsWithDepositGestiune && this.locationsWithDepositGestiune.length) {
            const foundDepositLocation = this.locationsWithDepositGestiune.find(loc => loc.true_id === order.supplierExternalLocationId)
            if (foundDepositLocation) {
              this.selectedDepositLocationId = foundDepositLocation.true_id
            }
          }

          if (
            this.myOrder.gestiune &&
            !this.gestiuneOptions.find(g => g.id === this.myOrder.gestiune)
          ) {
            this.gestiuneOptions.push({
              id: this.myOrder.gestiune,
              name: this.myOrder.gestiune
            })
          }
        } else {
          console.error('Comandă invalidă primită:', data)
          swal({
            title: 'Eroare',
            text: 'Comanda nu a fost găsită.',
            type: 'error',
            timer: 2000,
            showConfirmButton: false
          })
        }
      } catch (error) {
        console.error('Eroare la fetch order:', error)
        swal({
          title: 'Eroare',
          text: 'A apărut o problemă la încărcarea comenzii.',
          type: 'error',
          timer: 2000,
          showConfirmButton: false
        })
      }
    }
  }
}
</script>
<style scoped>
.v-select input[type=search], .v-select input[type=search]:focus,
.v-select.searchable .dropdown-toggle {
  min-height: 46px;
  height: 46px;
}
.v-select .dropdown-toggle {
  height: 46px;
}
.btn-primary {
padding: 5px 50px;
}
.el-select,
.el-input {
display: block;
}
.button-group {
  display: flex; /* Folosește flexbox pentru alinierea orizontală */
  justify-content: flex-end; /* Aliniază butoanele la dreapta */
}
.button-group .btn {
  margin-right: 10px; /* Adaugă un spațiu între butoane */
}
.button-group .btn:last-child {
  margin-right: 0; /* Elimină marginea dreaptă pentru ultimul buton */
}
.v-select-loader {
  position: absolute;
  right: 55px;
  top: 34%;
  transform: translateY(-50%);
  border: 3px solid #e0e0e0;     /* mai deschis */
  border-top: 3px solid #007bff;  /* mai contrastant */
  border-radius: 50%;
  width: 24px;                    /* mai mare */
  height: 24px;
  animation: spin 0.8s linear infinite;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.table thead tr > th {
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/Suppliers/ManagementMyOrdersSuppliersForm.vue